import React from 'react'

import ItemCardListDefault from './listDefault'
import ItemCardGridDefault from './gridDefault'

import ItemCardListAudio from './listAudio'
import ItemCardGridAudio from './gridAudio'

import ItemCardGridVideo from './gridVideo'
import { reportVideoProgress } from '../../../common/analytics/videoHiveAnalytics'

const ItemCard = ({
  viewType,
  videoMuted,
  itemProps,
  currentSite
}) => {
  if (viewType === 'grid') {
    if (currentSite === 'audiojungle') {
      return (
        <ItemCardGridAudio
          {...itemProps}
        />
      )
    } else if (currentSite === 'videohive') {
      return (
        <ItemCardGridVideo
          reportVideoProgress={reportVideoProgress}
          muted={videoMuted}
          {...itemProps}
        />
      )
    }

    return (
      <ItemCardGridDefault
        {...itemProps}
      />
    )
  }

  if (currentSite === 'audiojungle') {
    return (
      <ItemCardListAudio
        {...itemProps}
      />
    )
  }
  return (
    <ItemCardListDefault
      {...itemProps}
    />
  )
}

export default ItemCard



// WEBPACK FOOTER //
// ./client/components/itemCard/index.js